import { Button, Card, ContentState } from '@omnipresentgroup/design-system';
import { type To, useNavigate } from 'react-router';

const GO_BACK = -1;

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Card>
      <ContentState
        id="not-found"
        variant="error"
        title="404"
        description="Page not found"
        callToAction={
          <Button onClick={() => navigate(GO_BACK as To, { replace: true })}>
            Back Home
          </Button>
        }
      />
    </Card>
  );
};
